import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  sk: {
    translation: {
      doctorReportTitle: "Lekárska správa",
      currentDateAndTime: "Aktuálny dátum a čas",
      searchDiagnosis: "Hľadať diagnózu",
      editMode: "Editačný režim",
      aiAssistant: "Odborný poradca",
      profile: "Profil",
      newDiagnosis: "Nové vyšetrenie",
      generateAiReport: "Vytvoriť lekársku správu",
      copy: "Kopírovať",
      addComment: "Vložiť poznámku",
      yes: "Áno",
      no: "Nie",
      dayUnit: "deň",
      daysUnit: "dní",
      daysUnitLess: "dni",
      hourUnit: "hodina",
      hoursUnit: "hodín",
      hoursUnitLess: "hodiny",
      monthUnit: "mesiac",
      monthsUnit: "mesiacov",
      monthsUnitLess: "mesiace",
      moreInfo: "Ďalšie informácie s.",
      moreInfoPlaceholder: "Ďalšie informácie k aktuálnemu vyšetreniu...",
      add: "Pridať",
      remove: "Odobrať",
      notDone: "Nerobený",
      leukocytes: "Leukocyty",
      proteins: "Bielkoviny",
      nitrites: "Nitrity",
      blood: "Krv",
      generatingReport: "Vytváram lekársku správu...",
      pleaseWaitGeneratingReport:
        "Prosím chvíľu počkajte! Vytváram Vašu lekársku správu.",
      generatedReport: "Lekárska správa",
      generatedWarning:
        "Tieto informácie sú určené výlučne na vzdelávacie účely pre zdravotníckych pracovníkov. Nenahrádza klinický úsudok, individuálne rozhodovanie lekára ani oficiálne odporúčania odborných spoločností či regulačných autorít.",
      originalReport: "Pôvodná lekárska správa",
      copyOriginalReport: "Kopírovať pôvodnú lekársku správu",
      copyGeneratedReport: "Kopírovať generovanú lekársku správu",
      editText: "Upraviť text",
      careful: "Pozor",
      moreDiagnosisInfo: "Zistiť viac",
      save: "Uložiť",
      moreDiagnosisInfoTitle: "Poznámky k vyšetreniu",
      chooseOneOption: "Vyberte jednu z možností",
      fastTextInput: "Rýchly písomný vstup",
      textInput: "Písomný vstup",
      numberInput: "Číselný vstup",
      numberNumberInput: "Dvojčíselný vstup",
      booleanTextField: "Vstup s rýchlou volbou",
      booleanTextFieldDefaultValue: "žiadny",
      treatment: "Navrhnutie liečby",
      aiAssistantWithReport: "Poradca k vyšetreniu",
      differentialDiagnosis: " Diferenciálna diagnostika",
      mkch10: "Vyhľadanie kódu MKCH-10",
      settings: "Nastavenia",
      name: "Meno",
      email: "E-mail",
      type: "Zameranie",
      logout: "Odhlásiť sa",
      revertUser: "Obnoviť pôvodné vyšetrenia",
      deleteAccountConfirmationTitle: "Zmazanie",
      deleteAccount: "Odstrániť účet",
      deleteAccountConfirmation:
        "Naozaj chcete zmazať váš účet? Touto akciou prídete o všetky Vaše dáta. Táto akcia je nevratná.",
      deleteAccountConfirmText: "Zmazať",
      revertUserConfirmation:
        "Naozaj chcete zmazať Vaše aktuálne vyšetrenia a nahradiť ich pôvodnou šablónou? Touto akciou prídete o všetky Vaše dáta. Táto akcia je nevratná.",
      revertUserConfirmText: "Zmazať a Obnoviť",
      appSettings: "Nastavenia aplikácie",
      downloadTemplate: "Stiahnuť šablónu",
      uploadTemplate: "Nahrať šablónu",
      language: "Jazyk",
      fontSize: "Velkosť písmen",
      theme: "Téma",
      cs: "Čeština",
      sk: "Slovenčina",
      en: "Angličtina",
      normal: "Normálna",
      large: "Veľká",
      light: "Svetlá",
      dark: "Tmavá",
      uploadTemplateLabel:
        "Sem kliknite pre nahranie súborov, alebo ich presuňte do tejto plochy.",
      uploadTemplateSuccess: "Súbor bol úspešne nahraný.",
      trialPeriodEnds: "Vaša skúšobná doba DoktorUI vyprší",
      standard: "Štandard",
      standardFeature1: "40+ predpripravených vyšetrení",
      standardFeature2: "Neobmedzený počet dekurzov",
      standardFeature3: "Možnosť výberu špecializácie",
      standardFeature4: "Nastavenie vzhľadu na mieru",
      premium: "Premium",
      premiumFeature1: "Všetky štrandard funkcie",
      premiumFeature2: "Vytváranie vlastných vyšetrení",
      premiumFeature3: "Úprava existujúcich šablón",
      premiumFeature4: "Prispôsobenie systému podľa vlastných potrieb",
      cancelSubscription: "Zrušiť predplatné",
      choose: "Zvoliť",
      subscription: "Predplatné",
      editModeTutorial: "Návod na používanie editačnému režimu",
      timestamp1: "Zmena pozície (presúvanie) komponentov a názvu vyšetrenia",
      timestamp2:
        "Vymazávanie a úprava komponentov - kolónky, záložky, Pozor/Zistiť viac",
      timestamp3: "Pridanie vyšetrenia, záložky a kolónky",
      timestamp4:
        "Pridanie typu kolónky - Písomný vstup, Číselný vstup a  Dvojčíselný vstup",
      timestamp5: "Pridanie typu kolónky Vstup s rýchlou voľbou",
      timestamp6:
        "Pridanie typu kolónky Výber jednej možnosti, viacerých možností a Kaskádový výber",
      timestamp7:
        "Pridanie typu kolónky Binárny výber, Výber Áno/Nie a Statický text",
      timestamp8: "Pridanie typu kolónky Text pridaný tlačidlom",
      timestamp9: "Pridanie typu kolónky Moč",
      option1: "Možnosť 1",
      option2: "Možnosť 2",
      option3: "Možnosť 3",
      option4: "Možnosť 4",
      option5: "Možnosť 5",
      suboption1: "Podmožnosť 1",
      suboption2: "Podmožnosť 2",
      suboption3: "Podmožnosť 3",
      suboption4: "Podmožnosť 4",
      selectField: "Výber jednej možnosti",
      multiSelectField: "Výber viacerých možností",
      cascaderField: "Kaskádový výber",
      buttonGroupField: "Binárny výber",
      booleanField: "Výber Áno / Nie",
      staticTextField: "Statický text",
      staticTextFieldValue:
        "Vopred pevne stanovený textový obsah, ktorý je automaticky vkladaný do lekárskej správy bez potreby manuálneho zadávania.",
      buttonField: "Text pridaný tlačidlom",
      buttonFieldValue:
        "Vopred pevne stanovený textový obsah, ktorý vložíte do lekárskej správy pomocou tlačidla.",
      urineField: "Moč",
      bmiCalculator: "BMI kalkulačka",
      weight: "Váha",
      height: "Výška",
      fieldName: "Názov položky",
      fieldNamePlaceholder: "Zadajte názov položky...",
      allowNoteOption: "Povoliť poznámku",
      back: "Späť",
      cancel: "Zrušiť",
      addField: "Pridať položku",
      editField: "Upraviť položku",
      next: "Pokračovať",
      defaultValue: "Predvyplnená hodnota",
      defaultValuePlaceholder: "Zadajte predvyplnenú hodnotu...",
      unit: "Jednotka",
      firstDefaultValue: "Prvá predvyplnená hodnota",
      secondDefaultValue: "Druhá predvyplnená hodnota",
      firstUnit: "Prvá jednotka",
      secondUnit: "Druhá jednotka",
      quickOption: "Rýchla voľba",
      selectOptions: "Možnosti pri výbere",
      newOption: "Nová možnosť",
      newSubOption: "Nová podmožnosť",
      optionName: "Názov možnosti",
      subOptionName: "Názov podmožnosti",
      reportValue: "Hodnota v lekárskej správe",
      areYouSureDelete1: "Naozaj chcete zmazať položku",
      areYouSureDelete2: "? Táto akcia je nevratná.",
      delete: "Zmazať",
      deleteTitle: "Zmazanie",
      currentValue: "Aktuálna hodnota",
      selectFieldsTitle: "Rýchly výber z preddefinovaných možností",
      staticTextFieldsTitle: "Vkladanie predvyplnených textov",
      customFieldsTitle: "Špecifické položky",
      createFieldMessage: "Nová položka vytvorená",
      newTab: "Nová záložka",
      option: "Možnosť",
      negative: "Negatívny",
      nameCannotBeEmpty: "Názov nemôže byť prázdny",
      tabName: "Názov záložky",
      valueThatWillBeDisplayed: "Hodnota ktorá sa zobrazí v lekárskej správe",
      tabEditTitle: "Upravenie záložky",
      editDone: "Položka bola úspešne upravená",
      editTitleDone: "Názov vyšetrenia bol úspešne zmenený",
      loading: "Načítavanie",
      areYouSureDuplicate: "Naozaj chcete duplikovať položku",
      duplicate: "Duplikovať",
      duplicateTitle: "Duplikovanie",
      loginTitle: "Prihlásenie",
      password: "Heslo",
      yourPassword: "Vaše heslo",
      forgotPassword: "Zabudli ste heslo?",
      signUp: "Zaregistrujte sa tu",
      dontHaveAccount: "Nemáte ešte účet?",
      login: "Prihlásiť sa",
      loggingIn: "Prebieha prihlasovanie...",
      yourEmail: "Vaša e-mailová adresa",
      errorWhileLoggingIn: "Nastala chyba pri prihlasovaní",
      errorWhileRecoveringPassword: "Nastala chyba pri aktualizácii hesla",
      recoverPasswordTitle: "Obnovenie hesla",
      recoverConfirmation:
        "Pokyny na obnovenie hesla boli odoslané na Vašu e-mailovú adresu.",
      backToLogin: "Späť na prihlásenie",
      recoverConfirm: "Zaslať email na obnovenie hesla",
      recoverConfirmInProgress: "Zasielam email...",
      alreadyHaveAccount: "Už máte účet?",
      loginHere: "Prihláste sa tu",
      errorWhileUpdatingPassword: "Nastala chyba pri aktualizácii hesla",
      updatePasswordTitle: "Aktualizácia hesla",
      updatePasswordConfirmation:
        "Vaše heslo bolo úspešne aktualizované. Teraz môžete prihlásiť sa.",
      haveToAgreeToTNC: "Musíte súhlasiť s obchodnými podmienkami",
      passwordsDoNotMatch: "Heslá sa nezhodujú",
      passwordInvalid:
        "Heslo musí mať aspoň 6 znakov, jedno veľké písmeno a číslo.",
      registerError: "Nastala chyba pri registrácii",
      accountCreationTitle: "Vytvorenie účtu",
      accountCreationConfirmation:
        "Ďakujeme za registráciu! Skontrolujte svoj e-mail a potvrďte registráciu.",
      repeatPassword: "Zopakujte heslo",
      tnc1: "Súhlasím s",
      tnc2: "obchodnými podmienkami",
      tnc3: "a",
      tnc4: "ochranou osobných údajov",
      creatingAccount: "Vytváram účet...",
      createAccount: "Vytvoriť účet",
      firstLoginTitle: "Prvé prihlásenie",
      firstLoginError: "Vyplňte prosím všetky povinné polia",
      title: "Titul",
      yourTitle: "Vaš titul",
      yourName: "Vaše krstné meno",
      yourSurname: "Vaše priezvisko",
      surname: "Priezvisko",
      ChooseDoctorType: "Zvoľte Vaše zameranie",
      generalDoctor: "Všeobecné Lekárstvo",
      pediatric: "Pediatria",
      empty: "Nechcem predvyplniť vyšetrenia",
      emptyInProfile: "Nedefinované",
      mandatoryFields: "Povinné polia sú označené hviezdičkou",
      phoneNumber: "Telefónne číslo",
      yourPhoneNumber: "Vaše telefónne číslo",
      initializingAccount: "Zakladám účet a predvypĺňam Vaše vyšetrenia",
      mayTakeSomeTime: "Tento proces môže trvať niekoľko minút",
      finished: "Hotovo",
      invalidPhoneNumber: "Zlý formát telefónneho čísla",
      dictation: "Diktácia",
      newDiagnosisItem: "Nové vyšetrenie",
      newTabItemSubjective: "Anamnéza",
      newTabItemObjective: "Vyšetrenie",
      newTabItemSubjectiveValue: "Subjektívne:",
      newTabItemObjectiveValue: "Objektívne:",
      newTabItem: "Nová záložka",
      copyName: "Kópia",
      confirm: "Potvrdiť",
      recordReport: "Nahrávanie lekárskej správy",
      analyzeAndSendReport: "Analyzovať a opraviť nahraný text",
    },
  },
  en: {
    translation: {
      doctorReportTitle: "Doctors Report",
      currentDateAndTime: "Current date and time",
      searchDiagnosis: "Search diagnosis",
      editMode: "Edit mode",
      calendar: "Calendar",
      profile: "Profile",
      newDiagnosis: "Reset values",
      generateAiReport: "Generate doctors report",
      copy: "Copy",
      addComment: "Add comment",
      yes: "Yes",
      no: "No",
      dayUnit: "day",
      daysUnit: "days",
      daysUnitLess: "days",
      hourUnit: "hour",
      hoursUnit: "hours",
      hoursUnitLess: "hours",
      monthUnit: "month",
      monthsUnit: "months",
      monthsUnitLess: "months",
      moreInfo: "Additional comments",
      moreInfoPlaceholder: "Additional comments for current diagnosis...",
      add: "Add",
      remove: "Remove",
      notDone: "Not done",
      leukocytes: "Leukocytes",
      proteins: "Proteins",
      nitrites: "Nitrites",
      blood: "Blood",
      generatingReport: "Generating report...",
      pleaseWaitGeneratingReport: "Please wait! Generating your report.",
      generatedReport: "Generated report",
      generatedWarning:
        "Attention: This feature is in beta and information may not be correct. Please check the correctness of the generated text.",
      originalReport: "Original report:",
      copyOriginalReport: "Copy original report",
      copyGeneratedReport: "Copy generated report",
      editText: "Edit generated report",
      careful: "Caution",
      moreDiagnosisInfo: "Additional information",
      save: "Save",
      moreDiagnosisInfoTitle: "Additional information for diagnosis",
      chooseOneOption: "Choose one option",
      fastTextInput: "Quick text input",
      textInput: "Text input",
      numberInput: "Number input",
      numberNumberInput: "Double number input",
      booleanTextField: "Input with a quick option",
      booleanTextFieldDefaultValue: "none",
      settings: "Settings",
      name: "Name",
      email: "E-mail",
      type: "Type",
      logout: "Logout",
      revertUser: "Restore default diagnoses",
      deleteAccount: "Delete account",
      deleteAccountConfirmationTitle: "User deletion",
      deleteAccountConfirmation:
        "Are you sure you want to delete your account? This action will delete all your data. This action is irreversible.",
      deleteAccountConfirmText: "Delete",
      revertUserConfirmation:
        "Are you sure you want to delete your current diagnoses and replace them with the default template? This action will delete all your data. This action is irreversible.",
      revertUserConfirmText: "Delete and Restore",
      appSettings: "Application settings",
      downloadTemplate: "Download template",
      uploadTemplate: "Upload template",
      language: "Language",
      fontSize: "Font size",
      theme: "Theme",
      cs: "Czech",
      sk: "Slovak",
      en: "English",
      normal: "Normal",
      large: "Large",
      light: "Light",
      dark: "Dark",
      uploadTemplateLabel:
        "Click here to upload the template file, or drop it here.",
      uploadTemplateSuccess: "File uploaded successfully.",
      trialPeriodEnds: "Your free trial period ends on",
      standard: "Standard",
      standardFeature1: "40+ predefined diagnoses",
      standardFeature2: "Unlimited number of reports",
      standardFeature3: "Option to choose specialization",
      standardFeature4: "Adjust the look and feel to your preferences",
      premium: "Premium",
      premiumFeature1: "All standard features",
      premiumFeature2: "Create your own diagnoses",
      premiumFeature3: "Edit existing templates",
      premiumFeature4: "Customize the system according to your needs",
      cancelSubscription: "Cancel subscription",
      choose: "Choose",
      subscription: "Subscription",
      editModeTutorial: "Edit mode tutorial",
      timestamp1:
        "Changing the position (moving) of components and the name of the diagnosis",
      timestamp2:
        "Deleting and editing components - fields, tabs, caution/additional information",
      timestamp3: "Adding a diagnosis, tabs and fields",
      timestamp4:
        "Adding fields - Quick text input, Number input and Double number input",
      timestamp5: "Adding fields - Quick option",
      timestamp6:
        "Adding fields - Single select, multiple select and cascading select",
      timestamp7:
        "Adding fields - Binary option, Yes/No option and Static text",
      timestamp8: "Adding fields - Text added by clicking a button",
      timestamp9: "Adding fields - Urine field",
      option1: "Option 1",
      option2: "Option 2",
      option3: "Option 3",
      option4: "Option 4",
      option5: "Option 5",
      suboption1: "Suboption 1",
      suboption2: "Suboption 2",
      suboption3: "Suboption 3",
      suboption4: "Suboption 4",
      selectField: "Select field",
      multiSelectField: "Multi select field",
      cascaderField: "Cascader field",
      buttonGroupField: "Button group field",
      booleanField: "Toggle",
      staticTextField: "Static text",
      staticTextFieldValue:
        "Text content that is automatically inserted into the doctor report without the need for manual input.",
      buttonField: "Text added by clicking a button",
      buttonFieldValue: "Text content added by clicking a button",
      urineField: "Urine",
      bmiCalculator: "BMI calculator",
      weight: "Weight",
      height: "Height",
      fieldName: "Field name",
      fieldNamePlaceholder: "Enter field name...",
      allowNoteOption: "Allow note option",
      back: "Back",
      cancel: "Cancel",
      addField: "Add field",
      editField: "Edit field",
      next: "Continue",
      defaultValue: "Default value",
      defaultValuePlaceholder: "Enter default value...",
      unit: "Unit",
      firstDefaultValue: "First default value",
      secondDefaultValue: "Second default value",
      firstUnit: "First unit",
      secondUnit: "Second unit",
      quickOption: "Quick option",
      selectOptions: "Select options",
      newOption: "New option",
      newSubOption: "New suboption",
      optionName: "Option name",
      subOptionName: "Suboption name",
      reportValue: "Value in the report",
      areYouSureDelete1: "Are you sure you want to delete item ",
      areYouSureDelete2: "? This action is irreversible.",
      delete: "Delete",
      deleteTitle: "Deletion",
      currentValue: "Current value",
      selectFieldsTitle: "Fields with options",
      staticTextFieldsTitle: "Pre-filled text",
      customFieldsTitle: "Specific fields",
      newTab: "New tab",
      createFieldMessage: "New field created",
      option: "Option",
      negative: "Negative",
      nameCannotBeEmpty: "Name cannot be empty",
      tabName: "Tab name",
      valueThatWillBeDisplayed: "Value that will be displayed in the report",
      tabEditTitle: "Edit tab",
      editDone: "Field successfully edited",
      editTitleDone: "Diagnosis title successfully changed",
      loading: "Loading",
      areYouSureDuplicate: "Are you sure you want to duplicate item",
      duplicate: "Duplicate",
      duplicateTitle: "Duplicate",
      loginTitle: "Login",
      password: "Password",
      yourPassword: "Your password",
      forgotPassword: "Forgot your password?",
      signUp: "Sign up here",
      dontHaveAccount: "Don't have an account yet?",
      login: "Login",
      loggingIn: "Logging in...",
      yourEmail: "Your email address",
      errorWhileLoggingIn: "An error occurred while logging in",
      errorWhileRecoveringPassword: "An error occurred while updating password",
      recoverPasswordTitle: "Recover password",
      recoverConfirmation:
        "Instructions for recovering your password have been sent to your email address.",
      backToLogin: "Back to login",
      recoverConfirm: "Send email to recover password",
      recoverConfirmInProgress: "Sending email...",
      alreadyHaveAccount: "Already have an account?",
      loginHere: "Login here",
      errorWhileUpdatingPassword: "An error occurred while updating password",
      updatePasswordTitle: "Update password",
      updatePasswordConfirmation:
        "Your password has been successfully updated. Now you can log in.",
      haveToAgreeToTNC: "You have to agree to the terms and conditions",
      passwordsDoNotMatch: "Passwords do not match",
      passwordInvalid:
        "Password must have at least 6 characters, one uppercase letter and one number.",
      registerError: "An error occurred while registering",
      accountCreationTitle: "Account creation",
      accountCreationConfirmation:
        "Thank you for registering! Please check your email and confirm registration.",
      repeatPassword: "Repeat password",
      tnc1: "I agree to",
      tnc2: "terms and conditions",
      tnc3: "and",
      tnc4: "privacy policy",
      creatingAccount: "Creating account...",
      createAccount: "Create account",
      firstLoginError: "Please fill in all required fields",
      title: "Title",
      yourTitle: "Your title",
      yourName: "Your name",
      yourSurname: "Your surname",
      surname: "Surname",
      ChooseDoctorType: "Choose your specialization",
      generalDoctor: "General Practitioner",
      pediatric: "Pediatric",
      empty: "I don't want to specialize",
      mandatoryFields: "Mandatory fields are marked with an asterisk",
      firstLoginTitle: "First login",
      phoneNumber: "Phone number",
      yourPhoneNumber: "Your phone number",
      initializingAccount: "Initializing account and filling out your template",
      mayTakeSomeTime: "This process may take some time",
      finished: "Finished",
      invalidPhoneNumber: "Invalid phone number format",
      dictation: "Dictation",
      emptyInProfile: "Unknown",
      newDiagnosisItem: "New diagnosis",
      newTabItemSubjective: "Subjective",
      newTabItemObjective: "Objective",
      newTabItemSubjectiveValue: "Subjective:",
      newTabItemObjectiveValue: "Objective:",
      newTabItem: "New tab",
      copyName: "Copy",
      confirm: "Confirm",
      recordReport: "Report dictation",
      analyzeAndSendReport: "Analyze and correct report",
    },
  },
  cs: {
    translation: {
      doctorReportTitle: "Lékařská správa",
      currentDateAndTime: "Aktuální datum a čas",
      searchDiagnosis: "Hledat diagnostiku",
      editMode: "Editační režim",
      calendar: "Kalendář",
      profile: "Profil",
      newDiagnosis: "Nové vyšetření",
      generateAiReport: "Vytvořit lekárskou správu",
      copy: "Kopírovat",
      addComment: "Přidat komentář",
      yes: "Ano",
      no: "Ne",
      dayUnit: "den",
      daysUnit: "dny",
      daysUnitLess: "dní",
      hourUnit: "hodina",
      hoursUnit: "hodiny",
      hoursUnitLess: "hodiny",
      monthUnit: "měsíc",
      monthsUnit: "měsíce",
      monthsUnitLess: "měsíců",
      moreInfo: "Další informace",
      moreInfoPlaceholder: "Další informace k aktuálnímu vyšetření...",
      add: "Přidat",
      remove: "Odebrat",
      notDone: "Neprovedeno",
      leukocytes: "Leukocyty",
      proteins: "Bílkoviny",
      nitrites: "Nitrity",
      blood: "Krev",
      generatingReport: "Vytvářím lekárskou správu...",
      pleaseWaitGeneratingReport:
        "Prosím čekejte! Vytvářím vaši lekárskou správu.",
      generatedReport: "Vygenerovaná lekárska správa",
      generatedWarning:
        "Tyto informace jsou určeny výhradně pro vzdělávací účely zdravotnických pracovníků. Nenahrazují klinický úsudek, individuální rozhodování lékaře ani oficiální doporučení odborných společností či regulačních autorit.",
      originalReport: "Původní lekárska správa",
      copyOriginalReport: "Kopírovat původní lekárskou správu",
      copyGeneratedReport: "Kopírovat vygenerovanou lekářskou správu",
      editText: "Upravit vygenerovanou lekářskou správu",
      careful: "Pozor",
      moreDiagnosisInfo: "Další informace",
      save: "Uložit",
      moreDiagnosisInfoTitle: "Poznámky k vyšetření",
      chooseOneOption: "Vyberte jednu možnost",
      fastTextInput: "Rychlý textový vstup",
      textInput: "Textový vstup",
      numberInput: "Číselný vstup",
      numberNumberInput: "Dvojčíselný vstup",
      booleanTextField: "Vstup s rychlou volbou",
      booleanTextFieldDefaultValue: "žádný",
      settings: "Nastavení",
      name: "Jméno",
      email: "E-mail",
      type: "Typ",
      logout: "Odhlásit se",
      revertUser: "Obnovit původní vyšetření",
      deleteAccount: "Smazat účet",
      deleteAccountConfirmationTitle: "Smazání účtu",
      deleteAccountConfirmation:
        "Opravdu chcete smazat svůj účet? Touto akci odstraníte všechna vaše data. Tato akce je nevratná.",
      deleteAccountConfirmText: "Smazat",
      revertUserConfirmation:
        "Opravdu chcete smazat Vaše aktuální vyšetření a nahradit je původní šablonou? Touto akcí přijdete o všechna Vaše data. Tato akce je nevratná.",
      revertUserConfirmText: "Smazat a obnovit",
      appSettings: "Nastavení aplikace",
      downloadTemplate: "Stáhnout šablonu",
      uploadTemplate: "Nahrát šablonu",
      language: "Jazyk",
      fontSize: "Velikost písma",
      theme: "Téma",
      cs: "Čeština",
      sk: "Slovenčina",
      en: "Angličtina",
      normal: "Normální",
      large: "Velká",
      light: "Světlá",
      dark: "Tmavá",
      uploadTemplateLabel:
        "Zde klikněte pro nahrání souboru šablony, nebo jej sem přetáhněte.",
      uploadTemplateSuccess: "Soubor úspěšně nahrán.",
      trialPeriodEnds: "Vaše bezplatná zkušební doba vyprší",
      standard: "Standard",
      standardFeature1: "40+ předem definovaných vyšetření",
      standardFeature2: "Neomezený počet zpráv",
      standardFeature3: "Možnost výběru specializace",
      standardFeature4: "Nastavení vzhledu podle svých preferencí",
      premium: "Premium",
      premiumFeature1: "Všechny standardní funkce",
      premiumFeature2: "Vytváření vlastních vyšetření",
      premiumFeature3: "Úprava existujících šablon",
      premiumFeature4: "Přizpůsobení systému podle vlastních potřeb",
      cancelSubscription: "Zrušit předplatné",
      choose: "Zvolit",
      subscription: "Předplatné",
      editModeTutorial: "Návod k editačnímu režimu",
      timestamp1: "Změna pozice (přesun) komponent a název vyšetření",
      timestamp2:
        "Mazání a úprava komponent - polí, záložky, pozor/další informace",
      timestamp3: "Přidání vyšetření, záložek a polí",
      timestamp4:
        "Přidání polí - Rychlý vstup textu, číselný vstup a dvojčíselný vstup",
      timestamp5: "Přidání polí - Rychlá volba",
      timestamp6:
        "Přidání polí - Jednoduchý výběr, vícenásobný výběr a kaskádový výběr",
      timestamp7: "Přidání polí - Binární výběr, Výběr Ano/Ne a statický text",
      timestamp8: "Přidání polí - Přidání textového pole kliknutím na tlačítko",
      timestamp9: "Přidání polí - Pole na moč",
      option1: "Možnost 1",
      option2: "Možnost 2",
      option3: "Možnost 3",
      option4: "Možnost 4",
      option5: "Možnost 5",
      suboption1: "Podmožnost 1",
      suboption2: "Podmožnost 2",
      suboption3: "Podmožnost 3",
      suboption4: "Podmožnost 4",
      selectField: "Výběr jedné možnosti",
      multiSelectField: "Výběr více možností",
      cascaderField: "Kaskádový výběr",
      buttonGroupField: "Binární výběr",
      booleanField: "Výběr Ano / Ne",
      staticTextField: "Statický text",
      staticTextFieldValue:
        "Automaticky vložený obsah, který je vložen do lékářské zprávy bez nutnosti ručního zadání.",
      buttonField: "Text přidaný kliknutím na tlačítko",
      buttonFieldValue: "Obsah, který je přidán kliknutím na tlačítko",
      urineField: "Moč",
      bmiCalculator: "BMI kalkulačka",
      weight: "Váha",
      height: "Výška",
      fieldName: "Název pole",
      fieldNamePlaceholder: "Zadejte název pole...",
      allowNoteOption: "Povolit možnost poznámky",
      back: "Zpět",
      cancel: "Zrušit",
      addField: "Přidat pole",
      editField: "Upravit pole",
      next: "Pokračovat",
      defaultValue: "Předvolená hodnota",
      defaultValuePlaceholder: "Zadejte předvolenou hodnotu...",
      unit: "Jednotka",
      firstDefaultValue: "První předvolená hodnota",
      secondDefaultValue: "Druhá předvolená hodnota",
      firstUnit: "První jednotka",
      secondUnit: "Druhá jednotka",
      quickOption: "Rychlá volba",
      selectOptions: "Možnosti výběru",
      newOption: "Nová možnost",
      newSubOption: "Nová podmožnost",
      optionName: "Název možnosti",
      subOptionName: "Název podmožnosti",
      reportValue: "Hodnota v lékářské správě",
      areYouSureDelete1: "Opravdu chcete odstranit položku ",
      areYouSureDelete2: "? Tato akce je nevratná.",
      delete: "Smazat",
      deleteTitle: "Smazání",
      currentValue: "Aktuální hodnota",
      selectFieldsTitle: "Pole s možnostmi",
      staticTextFieldsTitle: "Předvyplněný text",
      customFieldsTitle: "Speciální pole",
      newTab: "Nová záložka",
      createFieldMessage: "Nové pole vytvořeno",
      option: "Možnost",
      negative: "Negativní",
      nameCannotBeEmpty: "Název nemůže být prázdný",
      tabName: "Název záložky",
      valueThatWillBeDisplayed: "Hodnota, která se zobrazí v lékářské správě",
      tabEditTitle: "Upravit záložku",
      editDone: "Pole úspěšně upraveno",
      editTitleDone: "Název vyšetření úspěšně změněn",
      loading: "Načítání",
      areYouSureDuplicate: "Opravdu chcete duplikovat položku",
      duplicate: "Duplikovat",
      duplicateTitle: "Duplikace",
      loginTitle: "Přihlášení",
      password: "Heslo",
      yourPassword: "Vaše heslo",
      forgotPassword: "Zapomněli jste heslo?",
      signUp: "Zaregistrujte se",
      dontHaveAccount: "Ještě nemáte účet?",
      login: "Přihlásit se",
      loggingIn: "Přihlašování...",
      yourEmail: "Vaše e-mailová adresa",
      errorWhileLoggingIn: "Při přihlašování došlo k chybě",
      errorWhileRecoveringPassword: "Při aktualizaci hesla došlo k chybě",
      recoverPasswordTitle: "Obnovit heslo",
      recoverConfirmation:
        "Pokyny na obnovení hesla byly odeslány na Vaši e-mailovou adresu.",
      backToLogin: "Zpět na přihlášení",
      recoverConfirm: "Poslat email pro obnovení hesla",
      recoverConfirmInProgress: "Posílám email...",
      alreadyHaveAccount: "Již máte účet?",
      loginHere: "Přihláste se zde",
      errorWhileUpdatingPassword: "Při aktualizaci hesla došlo k chybě",
      updatePasswordTitle: "Aktualizovat heslo",
      updatePasswordConfirmation:
        "Vaše heslo bylo úspěšně aktualizováno. Nyní můžete se přihlásit.",
      haveToAgreeToTNC: "Musíte souhlasit s podmínkami",
      passwordsDoNotMatch: "Hesla se neshodují",
      passwordInvalid:
        "Heslo musí mít alespoň 6 znaků, jedno velké písmeno a jedno číslo.",
      registerError: "Při registraci došlo k chybě",
      accountCreationTitle: "Vytvoření účtu",
      accountCreationConfirmation:
        "Děkujeme za registraci! Prosím zkontrolujte svůj e-mail a potvrďte registraci.",
      repeatPassword: "Zopakujte heslo",
      tnc1: "Souhlasím s",
      tnc2: "podmínkami",
      tnc3: "a",
      tnc4: "zásadami ochrany osobních údajů",
      creatingAccount: "Vytvářím účet...",
      createAccount: "Vytvořit účet",
      firstLoginError: "Vyplňte prosím všechna povinná pole",
      title: "Titul",
      yourTitle: "Váš titul",
      yourName: "Vaše jméno",
      yourSurname: "Vaše příjmení",
      surname: "Příjmení",
      ChooseDoctorType: "Zvolte Vaši specializaci",
      generalDoctor: "Všeobecné Lékařství",
      pediatric: "Pediatrie",
      empty: "Nechci předvyplnit vyšetření",
      emptyInProfile: "Nedefinováno",
      mandatoryFields: "Povinné pole jsou označeny hvězdičkou",
      firstLoginTitle: "První přihlášení",
      phoneNumber: "Telefonní číslo",
      yourPhoneNumber: "Vaše telefonní číslo",
      initializingAccount: "Zakládám účet a předvyplňuji Vaše vyšetření",
      mayTakeSomeTime: "Tento proces může trvat několik minut",
      finished: "Hotovo",
      invalidPhoneNumber: "Neplatný formát telefonního čísla",
      dictation: "Diktace",
      newDiagnosisItem: "Nové vyšetření",
      newTabItemSubjective: "Anamnéza",
      newTabItemObjective: "Vyšetření",
      newTabItemSubjectiveValue: "Subjektivní:",
      newTabItemObjectiveValue: "Objektivní:",
      newTabItem: "Nová záložka",
      copyName: "Kopie",
      confirm: "Potvrdit",
      recordReport: "Nahrávání lékářské zprávy",
      analyzeAndSendReport: "Analyzovat a opravit nahraný text",
    },
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "sk",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
